import {
  type CreateLinkParams,
  type UpdateLinkParams,
  linkCreateResultSchema,
  linkListSchema,
  resolvedLinkSchema,
} from '@/types/link';
import { INTERNAL_V1, damRequest } from '@/hooks/damRequest';

const NODEBASE = `${INTERNAL_V1}/nodes`;
const LINKBASE = `${INTERNAL_V1}/links`;

export const createLink = async ({ nodeId, body }: CreateLinkParams, token?: string) => {
  const response = await damRequest('POST', `${NODEBASE}/${nodeId}/links`, token, { body });
  return linkCreateResultSchema.parse(response).links;
};

export const updateLink = async ({ nodeId, linkId, body }: UpdateLinkParams, token?: string) => {
  const response = await damRequest('PUT', `${NODEBASE}/${nodeId}/links/${linkId}`, token, { body });
  return linkCreateResultSchema.parse(response).links;
};

export const getNodeLinkList = async (params: { nodeId: string; offset: number; limit: number }, token?: string) => {
  const response = await damRequest(
    'GET',
    `${NODEBASE}/${params.nodeId}/links?offset=${params.offset}&limit=${params.limit}`,
    token,
  );
  return linkListSchema.parse(response);
};

export const deleteLink = ({ nodeId, linkId }: { nodeId: string; linkId: string }, token?: string) =>
  damRequest('DELETE', `${NODEBASE}/${nodeId}/links/${linkId}`, token);

export const resolveLink = async ({ token: linkToken }: { token: string }, authToken?: string) => {
  const response = await damRequest('GET', `${LINKBASE}/${linkToken}`, authToken);
  return resolvedLinkSchema.parse(response);
};
